import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { SmallGridListEntry } from "frontend/contentful/schema/blocks";
import {
  SimpleGridList,
  SimpleGridListItemProps,
} from "design-system/components/blocks/simple-grid-list/simple-grid-list";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";
import { createComponentHeaderProps } from "../primitives/component-header.props";
import { useContentful } from "frontend/hooks/use-contentful";

interface SmallGridListOptions {
  headerAbove?: boolean;
}

export const ContentfulSmallGridList = createContentfulComponent<
  SmallGridListEntry,
  SmallGridListOptions
>(({ entry, options, createEditAttributes }) => {
  const { getEntries } = useContentful();

  const items: Array<SimpleGridListItemProps> = [];
  const headerContent = createComponentHeaderProps(entry.fields.header);

  getEntries(entry.fields.listItems)?.forEach((item) => {
    items.push({
      title: (
        <RenderContentfulRichText
          document={item.fields.title}
          disableParagraphs
        />
      ),
      content: <RenderContentfulRichText document={item.fields.description} />,
      editAttributes: {
        title: createEditAttributes({ entry: item, fieldId: "title" }),
        description: createEditAttributes({
          entry: item,
          fieldId: "description",
        }),
      },
    });
  });

  return (
    <SimpleGridList
      items={items}
      align={entry.fields.alignment}
      headerContent={headerContent}
      HeadingLevel={options?.headerAbove ? "h3" : "h2"}
    />
  );
});
